"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaTableauPanneauFiltre = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaTableauPanneauFiltre = /*#__PURE__*/function (_Component) {
  _inherits(MfaTableauPanneauFiltre, _Component);

  var _super = _createSuper(MfaTableauPanneauFiltre);

  function MfaTableauPanneauFiltre(props) {
    var _this;

    _classCallCheck(this, MfaTableauPanneauFiltre);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "mettreAJourValeurs", void 0);

    _defineProperty(_assertThisInitialized(_this), "effacerOrdre", void 0);

    _defineProperty(_assertThisInitialized(_this), "elementChargeur", void 0);

    _defineProperty(_assertThisInitialized(_this), "elementPanneau", void 0);

    _this.state = {
      choixOrdonne: false
    };
    return _this;
  }

  _createClass(MfaTableauPanneauFiltre, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      this.mettreAJourValeurs = nextProps.valeurs && !nextState.valeurs;
      this.effacerOrdre = this.props.visible && !nextProps.visible;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.mettreAJourValeurs) {
        var valeurs = this.props.valeurs || [];
        var choix = this.props.choix || [];
        this.setState({
          valeurs: valeurs
        });
      }

      if (this.props.choixOrdonne && !this.state.choixOrdonne) {
        this.setState({
          choixOrdonne: true
        });
      }

      if (this.effacerOrdre) {
        this.setState({
          choixOrdonne: false
        });
      }
    }
  }, {
    key: "surCaseCliquee",
    value: function surCaseCliquee(choix, evennement) {
      var caseACocher = evennement.currentTarget.getElementsByTagName('input')[0];
      var cliquee = caseACocher && caseACocher.checked;
      this.props.surCaseCliquee(choix, !cliquee);
    }
  }, {
    key: "aDesValeurs",
    value: function aDesValeurs() {
      return this.props.valeurs && this.props.valeurs.length;
    }
  }, {
    key: "surDefilement",
    value: function surDefilement(evennement) {
      var rectPanneau;
      var rectChargeur;

      if (this.elementPanneau) {
        rectPanneau = this.elementPanneau.getBoundingClientRect();
      }

      if (this.elementChargeur) {
        rectChargeur = this.elementChargeur.getBoundingClientRect();
      }

      if (rectChargeur && rectPanneau && rectPanneau.y + rectPanneau.height >= rectChargeur.y) {
        this.props.surChargeurFiltreVisible();
      }
    }
  }, {
    key: "renderBasCorps",
    value: function renderBasCorps(choix) {
      var _this2 = this;

      if (this.props.choix.length >= this.props.limiteChoix) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "mfa-notification mfa-rouge mfa-tableau-panneau-limitechoix"
        }, "Limite de choix atteinte. Utilisez la recherche pour filtrer les r\xE9sultats.");
      }

      return this.props.total > choix.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-tableau-panneau-chargeurchoix-div",
        ref: function ref(el) {
          return el && (_this2.elementChargeur = el);
        }
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, {
        className: "mfa-tableau-panneau-chargeurchoix",
        active: true
      })) : null;
    }
  }, {
    key: "renderCorps",
    value: function renderCorps() {
      var _this3 = this;

      var _this$props = this.props,
          choix = _this$props.choix,
          valeurs = _this$props.valeurs;

      if (!choix) {
        return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, {
          className: "mfa-tableau-panneau-chargeur",
          active: true
        });
      }

      if (!valeurs) {
        valeurs = [];
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-tableau-panneau-corps",
        ref: function ref(el) {
          return el && (_this3.elementPanneau = el);
        },
        onScroll: this.surDefilement.bind(this)
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.List, null, choix.map(function (choi) {
        return /*#__PURE__*/_react.default.createElement(_semanticUiReact.List.Item, {
          onClick: function onClick(evennement) {
            return _this3.surCaseCliquee(choi, evennement);
          },
          className: "mfa-tableau-panneau-item",
          key: choi
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Checkbox, {
          name: choi,
          checked: valeurs.indexOf(choi) !== -1
        }), /*#__PURE__*/_react.default.createElement("span", null, choi)));
      })), this.renderBasCorps(choix));
    }
  }, {
    key: "obtenirBoutonTopMenu",
    value: function obtenirBoutonTopMenu(fonction, nomIcone) {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "mfa-tableau-panneau-filtre-bouton",
        onClick: fonction
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: nomIcone
      }));
    }
  }, {
    key: "effacerValeurs",
    value: function effacerValeurs(evennement) {
      var _this4 = this;

      this.setState({
        valeurs: []
      }, function () {
        _this4.props.effacerValeurs(evennement);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (!this.props.visible) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Segment, {
        className: "mfa-tableau-panneau",
        raised: true,
        onClick: function onClick(evennement) {
          return evennement.stopPropagation();
        }
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Container, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-tableau-panneau-enveloppe"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-tableau-panneau-boutons"
      }, this.obtenirBoutonTopMenu(function (evennement) {
        return _this5.effacerValeurs(evennement);
      }, 'eraser', this.props.effacerDesactive), this.obtenirBoutonTopMenu(function (evennement) {
        return _this5.props.fermerPanneau(evennement);
      }, 'close'))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Search, {
        className: "mfa-ib",
        input: {
          placeholder: 'Rechercher...'
        },
        open: false,
        value: this.props.termeRecherche || '',
        onSearchChange: this.props.changementRecherche
      })), this.renderCorps())));
    }
  }]);

  return MfaTableauPanneauFiltre;
}(_react.Component);

exports.MfaTableauPanneauFiltre = MfaTableauPanneauFiltre;